import type { EgsBeddingType, EgsCategoryMeta, EgsCollectedBy, EgsGuestType, EgsRateType } from './types';

export const EGS_CATS: Array<EgsCategoryMeta> = [
  {
    key: 'adult',
    guestType: 'Extra Adult',
    label: 'Adult',
    question: 'Can this room accommodate at least 1 Extra Adult?',
    ages: 'from',
  },
  {
    key: 'child',
    guestType: 'Extra Child',
    label: 'Child',
    question: 'Can this room accommodate at least 1 Extra Child?',
    ages: 'both',
  },
  {
    key: 'infant',
    guestType: 'Extra Infant',
    label: 'Infant',
    question: 'Can this room accommodate at least 1 Extra Infant?',
    ages: 'to',
  },
];

export const EGS_BEDDING_OPTIONS: ReadonlyArray<EgsBeddingType> = [
  'Existing Bedding (Part of Standard Bedding Config)',
  'Cot',
  'Rollaway bed',
  'Daybed',
  'Single sofa bed',
  'Double sofa bed',
  'Other',
];

export const EGS_RATE_TYPE_OPTIONS: ReadonlyArray<EgsRateType> = ['Per Stay', 'Daily Rate'];

export const EGS_GUEST_TYPE_OPTIONS: ReadonlyArray<EgsGuestType> = ['Extra Adult', 'Extra Child', 'Extra Infant'];

export const EGS_COLLECTED_BY_OPTIONS: ReadonlyArray<EgsCollectedBy> = ['Free of Charge', 'Paid at Booking Stage'];
